import { supabase } from "@/services/supabase/createClient";
import { onError } from "@/services/onError";

export const createTeam = async (teamName: string) => {
  const { data, error } = await supabase.rpc("create_team", { team_name: teamName });

  if (error) {
    onError(error);
    return;
  }

  return { teamId: data };
};
